 <template>
    <div class="activity-content">
        <div class="activity-banner">
            <img src="../../assets/images/jxk-banner.png" alt />
            <a href="javascript:;" class="go-back activity-back" @click="e=>this.$router.push('/subject/tjx')"></a>
        </div>
        <div class="activity-list">
            <div class="a-list-item">
                <div class="left-item">
                    <img src="../../assets/images/jxk-icon1.png" class="a-item-icon" alt />
                </div>
                <div class="right-item">
                    <h5>活动时间</h5>
                    <div class="text-item-warp">
                        <div class="text-item">2020年11月1日-2020年12月31日</div>
                    </div>
                </div>
            </div>
            <div class="a-list-item">
                <div class="left-item">
                    <img src="../../assets/images/jxk-icon2.png" class="a-item-icon" alt />
                </div>
                <div class="right-item">
                    <h5>活动对象</h5>
                    <div class="text-item-warp">
                        <div class="text-item">钛金鑫卡、世界白金鑫卡</div>
                        <div class="apply-button-wrapper">
                             <a href="javascript:;" @click="applyLink"  class="apply-activity-btn" ></a>
                        </div> 
                    </div>
                </div>
            </div>
            <div class="a-list-item">
                <div class="left-item">
                    <img src="../../assets/images/jxk-icon3.png" class="a-item-icon" alt />
                </div>
                <div class="right-item">
                    <h5>活动内容</h5>
                    <div class="text-item-warp">
                       
                        <div class="text-item">
                        世界白金鑫卡、钛金鑫卡持卡人线上消费除基本消费积分外，可以获得4倍消费金额的奖励积分，同一客户每个自然月内消费奖励积分累计上限不超过20万，且当月获得的总积分不超过个人消费信用额度的10倍。</br>本次活动的奖励积分上限为12亿积分，先消费先得，送完即止。
                        </div>
                    </div>
                </div>
            </div>
            <div class="a-list-item a-footer-item">
                <div class="rule-details">
                    <h5>温馨提示</h5>
                    <div class="rule-text">
                        <p>1.本活动仅限上海农商银行钛金鑫卡、世界白金鑫卡持卡人使用上海农商银行钛金鑫卡、世界白金鑫卡持卡参与，消费类型限线上交易计信用卡积分的消费。</p>
                        <p>2．线上交易：包括支付宝、财付通、银联云闪付、京东支付、美团支付、苏宁支付、APPLEPAY、HUAWEIPAY、SAMSUNGPAY以及银联二维码支付。</p>
                        <div class="more-text" v-show="isShow">
                            <p>3.同一客户活动期内，当月线上消费奖励积分累计上限20万，且当月线下积分与线上积分之和不得超过该客户我行消费信用额度的10倍。同一客户指按同一身份证号的本行信用卡主卡客户。附属卡消费并入主卡账户统一计算，附属卡不单独获赠积分。</p>
                            <p>4.积分入账时间：活动期间积分到账时间与现有消费积分到账时间相同，即消费交易日后1日内可查询到账积分。</p>
                            <p>5.本次活动奖励积分上限为12亿积分，将根据持卡人消费达标的顺序依次进行积分赠予，活动将于积分赠完后结束。</p>
                            <p>6.积分赠送示例：客户A钛金鑫卡额度30万元，11月线上消费金额为1万元，则客户A获得基础积分1万分，获得奖励积分4万分，合计5万积分；客户B世界白金鑫卡额度10万元,11月线上消费金额为6万元，非线上计积分交易3万元，故可获得线上消费基础6万积分、非线上计积分交易3万元，由于赠送积分封顶值为20万积分，因此获赠额外奖励20万分，合计29万积分；客户C世界白金鑫卡额度2万元，其11月线上消费金额5万元，其可获得线上消费基础5万积分，以及可获赠额外奖励20万分，应合计25万积分，由于受到持卡人信用卡额度10倍限制，因此客户C 11月可获得积分20万分。</p>
                            <p>7.本积分活动内容及细则同时需遵循本行账户积分规则执行。活动期间，如遇我行举办的其他同类型积分活动，则活动不做叠加，我行默认持卡人参加积分倍数高的活动。</p>
                            <p>8.上海农商银行保留追回不符合条件但已赠送的积分的权利，如持卡人发生任何虚假、欺诈、套现、用于经营性目的、其他真实性合法性存在问题等不正常交易，或持卡人绝配合上海农商银行进行调查，或符合本活动条件的交易最终被撤销或退货的，则上海农商银行保留对相关交易进行调查核实、拒绝该持卡人参加本活动、取消其获赠积分的权利。</p>
                            <p>9.持卡人知晓并同意，上海农商银行有权对持卡人用卡、还款、资信及风险状况进行综合评估。持卡人如有下述任何一种情况，其享受本活动的资格将被取消，包括但不限于当前账户出现欠款逾期、销户、冻结及其他非正常状态；出现所持信用卡过期、被停用、持卡人自行注销信用卡、违反《上海农商银行信用卡章程》及《上海农商银行信用卡（个人卡）领用合约》或本活动细则及相关规定的。</p>
                            <p>10.如发现持卡人参与活动过程中存在任何利用系统漏洞或规则漏洞、外挂软件、插件等手段或工具套取活动奖励、损害活动规则、扰乱正常活动秩序等行为的，包括但不限于使用外挂获取活动资格、恶意刷单、有偿转赠权益、与商户串通、倒卖活动奖励、冒用他人信息参与活动、进行虚假交易等，上海农商银行有权取消持卡人参加本次活动及获得本活动奖励的资格，并有权取消或收回其因参加本次活动所获的奖励。同时，上海农商银行保留追究其法律责任的权利。若系统漏洞、故障或其他原因致使系统无法正常运行，导致持卡人获得与本活动规则不符的奖励，上海农商银行保留取消或收回持卡人参加本活动所获的回馈和奖励权利。</p>
                            <p>11.其他未尽事宜，仍受《上海农商银行信用卡章程》、《上海农商银行信用卡（个人卡）领用合约》、监管机构及银行卡组织相关规定约束。</p>
                            <p>12.在法律允许范围内，上海农商银行有权修订本活动条款及细则（包括但不限于参加资格、消费时间及奖励方式等）、暂停或取消本活动，并经相关途径（如上海农商银行官方网站、对账单、短信、“上海农商银行信用卡”微信公众号、上海农商银行信用卡APP或各分支网点等）公告后生效。活动详情以上海农商银行前述各公告途径的最新公布内容为准，或咨询24小时客服热线021-962999或4006962999。</p>
                        </div>
                    </div>
                    <a
                        href="javascript:;"
                        class="more-rule"
                        @click="changeMoreRule"
                        v-show="!isShow"
                    >展开详情</a>
                    <div class="collect-wrap" v-show="isShow">
                        <div class="collect-btn" @click="changeMoreRule">
                            <i class="collect-icon"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <cube-popup type="my-popup" ref="card-Popup">
            <div class="card-modal-frames">
                <img :src="currentModals" />
                <i class="card-icon-close close-btn close-icon" @click="closePopup"></i>
                <!-- <a href="javascript:;" @click="e=>$listeners.routePusht('/map')" class="see-net"></a> -->
            </div>
        </cube-popup>
    </div>
</template>

<script>
import {mapState} from 'vuex';

export default {

    data() {
        return { isShow: false,
                 currentModals:'',
                 name:'',
                applyData:{},
                modals:{
                bjx: require("@/assets/images/bjx-modal@2x.png"),
                tjx: require("@/assets/images/tjx-modal@2x.png")
                },
                test:''
             };
    },
    computed:{
      ...mapState(['subjectActivity'])
    }
    ,
    mounted() {
        console.log(this.subjectActivity)
        this.applyData = this.subjectActivity.tjx.bjxk.applyData || {};

    },
    methods: {
        changeMoreRule() {
            this.isShow = !this.isShow;
            // this.$test("HF a-detail-2");
        },
        showPopup(refId) {
            const component = this.$refs[refId];
            component.show();
        },
        applyLink() {
            this.$test(this.applyData.test);
            if (this.applyData.type == "out") {
                window.location.href = this.applyData.url;
            } else {
                if(this.applyData.type=="page"){
                      this.routerPush(this.applyData.url);
                }else {
                      this.currentModals = this.modals[this.applyData.url];
                      console.log(123)
                      this.showPopup("card-Popup");
                }
            }
        },
        routerPush(path,cb) {
            if (typeof path === "string") {
                this.$router.push(path,()=>{
                    cb&&cb();
                });
            } else {
                this.$router.push({
                    name: path.path,
                    params: { name: path.name }
                });
            }
        },
        hidePopup(refId) {
            const component = this.$refs[refId];
            component.hide();
        },
         closePopup() {
            this.hidePopup("card-Popup");
        },

    }
};
</script>

<style lang="scss" scoped>
</style>